import React, {Component} from 'react';
import {SESSION_USER } from '../constants';
export default class NavPopUp extends Component {
    
  
    componentDidMount(){

    }

    render(){

    	    let roleName='';
            let user = JSON.parse(localStorage.getItem(SESSION_USER));
             if(user && user.roles){
                roleName=user.roles[0]
             }


        return (<li>

                         {roleName==='ROLE_ADMIN' ?<a href="/settings"><i className="ti-settings"></i> Company Settings</a>:''}
                 </li>
        	);
    }

}